module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("j2k0c"))).then(() => parcelRequire('3a9aZ'));